import { Quad } from 'gsap';
import type { SlideOutOptions, SlideUpFadeInOptions } from './slide.types';

export const defaultSlideOutOptions: SlideOutOptions = {
  ease: 'Power3.easeOut',
  duration: 0.4,
  to: 100,
};

export const defaultSlideUpFadeInOptions: SlideUpFadeInOptions = {
  ease: Quad.easeInOut,
  duration: 0.5,
  from: 30,
  to: 0,
  fadeTo: 1,
  clearProps: 'y',
  autoAlpha: false,
};

export const defaultSlideHorizontallyOptions: SlideUpFadeInOptions = {
  ease: Quad.easeInOut,
  duration: 0.5,
  from: 0,
  to: 30,
  fadeTo: 1,
  clearProps: 'x',
  autoAlpha: false,
};
